module.exports = __webpack_public_path__ + "static/media/BG-website.81775d5a.png";